import React from 'react';
import { Gamepad2, Joystick, Bot, Brain, Laptop, Wrench, Smartphone, ArrowRight } from 'lucide-react';
export function QueIncluye() {
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="que-incluye" className="py-5 sm:py-14 bg-white relative overflow-hidden" data-id="element-153">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-5" data-id="element-154">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-blue-600 rounded-full blur-3xl" data-id="element-155"></div>
        <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-purple-600 rounded-full blur-3xl" data-id="element-156"></div>
      </div>

      <div className="max-w-6xl mx-auto px-3 sm:px-6 relative z-10" data-id="element-157">
        <div className="text-center mb-4 sm:mb-10" data-id="element-158">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2 sm:mb-4" data-id="element-159">
            ¿Qué incluye el{' '}
            <span className="text-[#f59e0b]" data-id="element-160">
              Kit Completo Tecnología Lista
            </span>
            ?
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-3xl mx-auto" data-id="element-161">
            Este mega combo reúne material de tecnología educativa en un solo
            lugar, con recursos prácticos, actuales y pensados para aplicar
            directamente en el aula.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-4 mb-4 sm:mb-10" data-id="element-162">
          {/* Card 1 */}
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-3 sm:p-5 hover:border-[#f59e0b] transition-colors duration-300 shadow-sm group" data-id="element-163">
            <div className="bg-blue-100 w-9 h-9 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center mb-2 sm:mb-3 group-hover:bg-blue-200 transition-colors" data-id="element-164">
              <Gamepad2 className="text-blue-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-165" />
            </div>
            <h3 className="text-sm sm:text-lg font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-166">
              Gamificación paso a paso
            </h3>
            <p className="text-gray-500 leading-snug text-xs sm:text-sm" data-id="element-167">
              Guía práctica para implementar estrategias de aprendizaje basadas
              en juegos, con ejemplos concretos, dinámicas listas para usar y
              herramientas para motivar a los estudiantes.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-3 sm:p-5 hover:border-[#f59e0b] transition-colors duration-300 shadow-sm group" data-id="element-168">
            <div className="bg-green-100 w-9 h-9 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center mb-2 sm:mb-3 group-hover:bg-green-200 transition-colors" data-id="element-169">
              <Joystick className="text-green-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-170" />
            </div>
            <h3 className="text-sm sm:text-lg font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-171">
              Gamificación en el aula
            </h3>
            <p className="text-gray-500 leading-snug text-xs sm:text-sm" data-id="element-172">
              Cómo utilizar dinámicas lúdicas como recursos educativos para
              mejorar la participación, la atención y el aprendizaje
              significativo.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-3 sm:p-5 hover:border-[#f59e0b] transition-colors duration-300 shadow-sm group" data-id="element-173">
            <div className="bg-purple-100 w-9 h-9 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center mb-2 sm:mb-3 group-hover:bg-purple-200 transition-colors" data-id="element-174">
              <Bot className="text-purple-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-175" />
            </div>
            <h3 className="text-sm sm:text-lg font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-176">
              Cómo sobrevivir a la IA
            </h3>
            <p className="text-gray-500 leading-snug text-xs sm:text-sm" data-id="element-177">
              Material clave para entender el impacto de la IA en la educación y
              aprender a aprovecharla como herramienta pedagógica en el aula.
            </p>
          </div>

          {/* Card 4 */}
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-3 sm:p-5 hover:border-[#f59e0b] transition-colors duration-300 shadow-sm group" data-id="element-178">
            <div className="bg-pink-100 w-9 h-9 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center mb-2 sm:mb-3 group-hover:bg-pink-200 transition-colors" data-id="element-179">
              <Brain className="text-pink-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-180" />
            </div>
            <h3 className="text-sm sm:text-lg font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-181">
              Infancia, tecnología y STEM
            </h3>
            <p className="text-gray-500 leading-snug text-xs sm:text-sm" data-id="element-182">
              Guía para desarrollar el pensamiento científico y tecnológico
              desde edades tempranas, promoviendo habilidades del siglo XXI.
            </p>
          </div>

          {/* Card 5 */}
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-3 sm:p-5 hover:border-[#f59e0b] transition-colors duration-300 shadow-sm group" data-id="element-183">
            <div className="bg-cyan-100 w-9 h-9 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center mb-2 sm:mb-3 group-hover:bg-cyan-200 transition-colors" data-id="element-184">
              <Laptop className="text-cyan-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-185" />
            </div>
            <h3 className="text-sm sm:text-lg font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-186">
              Computación en la escuela
            </h3>
            <p className="text-gray-500 leading-snug text-xs sm:text-sm" data-id="element-187">
              Manual práctico para integrar la informática en el aula con
              estrategias didácticas adaptadas a la educación actual.
            </p>
          </div>

          {/* Card 6 */}
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-3 sm:p-5 hover:border-[#f59e0b] transition-colors duration-300 shadow-sm group" data-id="element-188">
            <div className="bg-orange-100 w-9 h-9 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center mb-2 sm:mb-3 group-hover:bg-orange-200 transition-colors" data-id="element-189">
              <Wrench className="text-orange-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-190" />
            </div>
            <h3 className="text-sm sm:text-lg font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-191">
              Aprender e inventar
            </h3>
            <p className="text-gray-500 leading-snug text-xs sm:text-sm" data-id="element-192">
              Propuestas creativas para trabajar proyectos digitales, fomentar
              la innovación y potenciar el aprendizaje activo.
            </p>
          </div>

          {/* Card 7 */}
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-3 sm:p-5 hover:border-[#f59e0b] transition-colors duration-300 shadow-sm group md:col-span-2 lg:col-span-3 lg:w-1/3 lg:mx-auto" data-id="element-193">
            <div className="bg-indigo-100 w-9 h-9 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center mb-2 sm:mb-3 group-hover:bg-indigo-200 transition-colors" data-id="element-194">
              <Smartphone className="text-indigo-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-195" />
            </div>
            <h3 className="text-sm sm:text-lg font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-196">
              Tecnología y educación
            </h3>
            <p className="text-gray-500 leading-snug text-xs sm:text-sm" data-id="element-197">
              Análisis de los desafíos, oportunidades y estrategias para enseñar
              en la era digital.
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-198"></div>
      </div>
    </section>;
}